import { Box, Paper } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { Navigate, useLocation } from 'react-router-dom';
import authBlobImage from '../../assets/other/auth-blob.png';
import AuthRightSideUI from './AuthRightSideUI';

export function AuthLayout({ children }) {
    const { user, isSimpleAuthenticated, getUserDetailsNotAsync, getUserDetails, setUserDetailsNotAsync, refreshSessionData } = useAuth();
    const [authenticated, setAuthenticated] = useState(false);
    const [loaded, setLoaded] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const checkAuth = async () => {
            setLoaded(false);
            try {
                let value = await isSimpleAuthenticated();
                setAuthenticated(value);
            } catch {
                setAuthenticated(false);
            } finally {
                setLoaded(true);
            }
        };
        checkAuth();
    }, [location.pathname]);

    if (!loaded) {
        return null;
    }

    if (authenticated) {
        return (
            <Navigate
                to={'/' + (location.search ? location.search : '') + (location.hash ? location.hash : '')}
                state={{
                    path: location.pathname + location.search + location.hash,
                    query: (location.search ? location.search : '') + (location.hash ? location.hash : ''),
                }}
            />
        );
    } else {
        return <AuthLayoutUI>{children}</AuthLayoutUI>;
    }
}

export const AuthLayoutUI = ({ children }) => {
    return (
        <Paper
            component={'main'}
            sx={{
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            <Box
                height={'100%'}
                width={{
                    xs: '100%',
                    md: '100%',
                    lg: '100%',
                }}
                display={'flex'}
                justifyContent={'center'}
                alignItems={'center'}
                padding={'1rem'}
                sx={{
                    backgroundImage: `url(${authBlobImage})`,
                    backgroundPosition: 'left top',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: '350px',
                }}
            >
                {children}
            </Box>
            {!window.location.hostname?.startsWith('tax.') && (
                <Box
                    height={'100%'}
                    width={{
                        xs: '100%',
                        md: '50%',
                        lg: '40%',
                    }}
                    display={{
                        xs: 'none',
                        md: 'flex',
                    }}
                    justifyContent={'center'}
                    alignItems={'center'}
                    overflow={'auto'}
                    padding={'2rem'}
                    sx={{
                        background: '#FAFAFA',
                    }}
                >
                    <AuthRightSideUI />
                </Box>
            )}
        </Paper>
    );
};

export default AuthLayout;
